import Repository from './Repository';
import { ShareCampaign, CustomerShareCampaign } from '@comsbi/common/src/types/models';

const resource = '/share_campaign';

export default {
  /**
   * 顧客シェアキャンペーン解決
   */
  resolveCustomerShareCampaign(shareCampaignId: string) {
    return Repository.post(`${resource}/${shareCampaignId}/resolve`);
  },
  /**
   * スタンプ付与(顧客シェアキャンペーンがなければ解決してから付与)
   */
  stamp(shareCampaignId: string, itemKey?: string) {
    return Repository.post(`${resource}/${shareCampaignId}/stamp/${itemKey}`);
  },
};
